// src/seo/helmetConfigs.js
import { Helmet } from "react-helmet"

export const MyteConstructionHelmet = () => (
  <Helmet>
    <title>Myte Construction – AI-Driven Jobsite Management</title>
    <meta name="description" content="Myte Construction Suite is a voice-enabled, AI-powered jobsite management platform for construction teams. From steel crews to payroll, speak your work into existence." />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://mytegroup.ai/myteconstruction" />

    {/* OG */}
    <meta property="og:type" content="website" />
    <meta property="og:title" content="Myte Construction – AI for the Jobsite" />
    <meta property="og:description" content="Streamline your construction workflows with AI-powered timesheets, material requests, and voice-driven data capture." />
    <meta property="og:url" content="https://mytegroup.ai/myteconstruction" />
    <meta property="og:image" content="https://mytegroup.ai/og-thumbnail.png" />
    <meta property="og:site_name" content="Myte Construction" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Myte Construction – AI for the Jobsite" />
    <meta name="twitter:description" content="Voice-enabled tools for foremen, PMs, and ironworkers. Built with steel crews in mind." />
    <meta name="twitter:image" content="https://mytegroup.ai/og-thumbnail.png" />
  </Helmet>
)
